module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAM1BMVEUAAAClpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaXf4eOrq6vq7O6ztLTWzBFuAAAADHRSTlMA8oQUU/nR9NLTzlREiFtjAAAAWklEQVQI112PSw7AIAhEUURtO6L3P20nLJrqCwteIHyEaO5mNasEJSFIJQwfdGVtOeCLdZVMm8N9THqWCjAdDAe6GMLDYLu2vbkeo45Fxxnk+R8ZL1zW7njhBdv6BwONWcwNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_clear.png
// module id = zPpc
// module chunks = 9